import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
	/** Pre */
	{
		path: '/',
		name: 'home',
		component: () => import(/* webpackChunkName: "default-paywall" */ '@/views/pre/Home.vue')
	},

	{
		path: '/offer-40off-home',
		name: 'offer-40off-home',
		component: () => import(/* webpackChunkName: "offer-40-off" */ '@/views/pre/Offer40offHome.vue')
	},

	{
		path: '/ny-2022-without-survey-home',
		name: 'ny-2022-without-survey-home',
		component: () =>
			import(/* webpackChunkName: "ny-2022-without-srv-home" */ '@/views/pre/NY2022WithoutSurveyHome.vue')
	},

	/** Paywalls */
	{
		path: '/paywall',
		name: 'paywall',
		component: () => import(/* webpackChunkName: "default-paywall" */ '@/views/paywall/Paywall.vue')
	},

	{
		path: '/paywall-after-cancel',
		name: 'paywall-after-cancel',
		component: () => import(/* webpackChunkName: "paywall-after-cancel" */ '@/views/paywall/PaywallAfterCancel.vue')
	},

	{
		path: '/black-friday',
		name: 'black-friday',
		component: () => import(/* webpackChunkName: "black-friday" */ '@/views/pre/BlackFridayHome.vue')
	},

	{
		path: '/black-friday-paywall',
		name: 'black-friday-paywall',
		component: () => import(/* webpackChunkName: "black-friday" */ '@/views/paywall/BlackFridayPaywall.vue')
	},

	{
		path: '/christmas-offer',
		name: 'christmas-offer',
		component: () => import(/* webpackChunkName: "christmas-offer" */ '@/views/pre/ChristmasOfferHome.vue')
	},

	{
		path: '/christmas-offer-paywall',
		name: 'christmas-offer-paywall',
		component: () => import(/* webpackChunkName: "christmas-offer" */ '@/views/paywall/ChristmasOfferPaywall.vue')
	},

	{
		path: '/offer-40off-paywall',
		name: 'offer-40off-paywall',
		component: () => import(/* webpackChunkName: "offer-40-off" */ '@/views/paywall/Offer40offPaywall.vue')
	},

	{
		path: '/upsale-trial',
		name: 'upsale-trial',
		component: () => import(/* webpackChunkName: "default-paywall" */ '@/views/paywall/UpsaleTrial.vue')
	},

	{
		path: '/offer-trial',
		name: 'offer-trial',
		component: () => import(/* webpackChunkName: "default-paywall" */ '@/views/paywall/OfferTrial.vue')
	},

	{
		path: '/ny22-paywall',
		name: 'ny22-paywall',
		component: () => import(/* webpackChunkName: "ny22-paywall" */ '@/views/paywall/NY22Paywall.vue')
	},

	{
		path: '/countdown-paywall',
		name: 'countdown-paywall',
		component: () => import(/* webpackChunkName: "countdown-paywall" */ '@/views/paywall/CountdownPaywall.vue')
	},

	{
		path: '/recipe-subscription',
		name: 'recipe-subscription',
		component: () => import(/* webpackChunkName: "recipe-subscription" */ '@/views/paywall/RecipeSubscription.vue')
	},

	/** Post */
	{
		path: '/workbooks',
		name: 'workbooks',
		component: () => import(/* webpackChunkName: "default-paywall" */ '@/views/post/Workbooks.vue')
	},

	{
		path: '/workout-workbook',
		name: 'workout-workbook',
		component: () => import(/* webpackChunkName: "default-paywall" */ '@/views/post/WorkoutWorkbook.vue')
	},

	{
		path: '/workbooks-v2',
		name: 'workbooks-v2',
		component: () => import(/* webpackChunkName: "workbooks-v2" */ '@/views/post/WorkbooksV2.vue')
	},

	{
		path: '/workbooks-bundle',
		name: 'workbooks-bundle',
		component: () => import(/* webpackChunkName: "default-paywall" */ '@/views/post/WorkbooksBundle.vue')
	},

	{
		path: '/workbooks-bundle-v2',
		name: 'workbooks-bundle-v2',
		component: () => import(/* webpackChunkName: "workbooks-bundle-v2" */ '@/views/post/WorkbooksBundleV2.vue')
	},

	{
		path: '/offer-92off-workbooks-bundle',
		name: 'offer-92off-workbooks-bundle',
		component: () => import(/* webpackChunkName: "offer-92-off" */ '@/views/post/Offer92offWorkbooksBundle.vue')
	},

	{
		path: '/success',
		name: 'success',
		component: () => import(/* webpackChunkName: "default-paywall" */ '@/views/post/Success.vue')
	},

	{
		path: '/summer-sale',
		name: 'summer-sale',
		component: () => import(/* webpackChunkName: "summer-sale" */ '@/views/paywall/SummerSaleOffer.vue'),
		props: (route) => ({
			paywallTheme: route.query.paywallTheme
		})
	},

	{
		path: '/after-purchase',
		name: 'after-purchase',
		component: () => import(/* webpackChunkName: "after-purchase" */ '@/views/post/SurveyAfterPurchase.vue')
	},
	{
		path: '/emotional-course',
		name: 'emotional-course',
		component: () => import(/* webpackChunkName: "summer-sale" */ '@/views/post/EmotionalCourse.vue')
	},
	{
		path: '/cancel-sub-offer',
		name: 'cancel-sub-offer',
		component: () => import(/* webpackChunkName: "cancel-sub-offer" */ '@/views/pre/survey/CancelSubOffer.vue')
	},
	{
		path: '/paywall-toggle',
		name: 'paywall-toggle',
		component: () => import(/* webpackChunkName: "paywall-toggle" */ '@/views/paywall/PaywallToggle.vue')
	},
	{
		path: '/slider-paywall',
		name: 'slider-paywall',
		component: () => import(/* webpackChunkName: "slider-paywall" */ '@/views/paywall/SliderPaywall.vue')
	},

	/** Survey */

	{
		path: '/survey',
		component: () => import(/* webpackChunkName: "srv" */ '@/views/pre/survey/Index.vue'),
		children: [
			// {
			// 	path: 'improving-life',
			// 	name: 'improving-life',
			// 	component: () => import(/* webpackChunkName: "srv" */ '@/views/pre/survey/ImprovingLife.vue')
			// },
			// {
			// 	path: 'state-of-mind',
			// 	name: 'state-of-mind',
			// 	component: () => import(/* webpackChunkName: "srv" */ '@/views/pre/survey/StateOfMind.vue')
			// },
			// {
			// 	path: 'diets',
			// 	name: 'diets',
			// 	component: () => import(/* webpackChunkName: "srv" */ '@/views/pre/survey/Diets.vue')
			// },
			// {
			// 	path: 'goals',
			// 	name: 'goals',
			// 	component: () => import(/* webpackChunkName: "srv" */ '@/views/pre/survey/Goals.vue')
			// },
			// {
			// 	path: 'result',
			// 	name: 'result',
			// 	component: () => import(/* webpackChunkName: "srv" */ '@/views/pre/survey/Result.vue')
			// },
			{
				path: 'rejection-reason',
				name: 'rejection-reason',
				component: () => import(/* webpackChunkName: "rejection-reason" */ '@/views/pre/survey/RejectionReason.vue')
			},
			// {
			// 	path: 'cancel-sub-question',
			// 	name: 'cancel-sub-question',
			// 	component: () =>
			// 		import(/* webpackChunkName: "cancel-sub-question" */ '@/views/pre/survey/CancelSubQuestion.vue')
			// },
			{
				path: 'grab-a-snack',
				name: 'grab-a-snack',
				component: () => import(/* webpackChunkName: "emotional-course" */ '@/views/survey/GrabASnack.vue')
			},
			{
				path: 'snack-trigger',
				name: 'snack-trigger',
				component: () => import(/* webpackChunkName: "emotional-course" */ '@/views/survey/SnackTrigger.vue')
			},
			{
				path: 'emotional-eating-course-intro',
				name: 'emotional-eating-course-intro',
				component: () =>
					import(/* webpackChunkName: "emotional-course" */ '@/views/survey/EmotionalEatingCourseIntro.vue')
			}
		]
	}

	// {
	// 	path: '/chat',
	// 	name: 'chat',
	// 	component: () => import(/* webpackChunkName: "chat" */ '@/views/fakechat/Index.vue')
	// }
]

const router = createRouter({
	history: createWebHashHistory(),
	routes,

	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition
		} else {
			return {
				top: 0
			}
		}
	}
})

export default router
